import { Grade, Competency } from '../types';

export const DATA_KEY = 'competency_board_data_v1';

// Утилиты для работы с сортировкой компетенций по числовым индексам
export function normalizeSortOrder(grades: Grade[]) {
  if (!grades || !Array.isArray(grades)) {
    return grades;
  }

  grades.forEach((grade) => {
    if (!grade || !grade.competencies || !Array.isArray(grade.competencies)) {
      return;
    }

    // Группируем компетенции по swimlaneId
    const swimlaneGroups: { [swimlaneId: string]: Competency[] } = {};
    grade.competencies.forEach((comp: Competency) => {
      if (!comp || !comp.swimlaneId) {
        return;
      }
      if (!swimlaneGroups[comp.swimlaneId]) {
        swimlaneGroups[comp.swimlaneId] = [];
      }
      swimlaneGroups[comp.swimlaneId].push(comp);
    });
    // Нормализуем сортировку для каждой группы
    Object.keys(swimlaneGroups).forEach((swimlaneId) => {
      const comps = swimlaneGroups[swimlaneId];
      comps.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
      comps.forEach((comp, index) => {
        comp.sortOrder = (index + 1) * 10;
      });
    });
  });
  return grades;
}
